import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  root: {
    padding: "100px 0px",
    width: "90%",
    maxWidth: "1216px",
    margin: "0 auto",
    fontFamily: "Montserrat",
    color: "black",
  },
  breadcrumb: {
    fontSize: "18px",
    marginBottom: "20px",
  },
  title: {
    fontSize: "48px",
    fontWeight: 600,
    marginBottom: "30px",
  },
  section: {
    marginBottom: "25px",
    lineHeight: 1.6,
    fontSize: "18px",
  },
  '@media (max-width: 768px)': {
    title: { fontSize: "32px" },
    section: { fontSize: "16px" },
  },
});

const PolicyLayout = ({ title, sections }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.breadcrumb}>
        <span className="grey-text">Home &gt; </span>
        <span>{title}</span>
      </div>

      <div className={classes.title}>{title}</div>

      {sections.map((text, index) => (
        <div key={index} className={classes.section}>
          {text}
        </div>
      ))}
    </div>
  );
};

export default PolicyLayout;
